export default __webpack_public_path__ + "static/media/left_icon_gray.146e50b5.svg";